// Configuration for production environment
import { validateAwsConfig } from './aws-config-validator';

const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: 'us-east-1_0eMW6muBW',
      userPoolClientId: '33nhseqo13a24a3hgo5b06gn7v',
      identityPoolId: 'us-east-1:235ff276-666c-4ce6-b583-fbeec012fb7b'
    }
  },
  Storage: {
    S3: {
      region: 'us-east-1',
      bucket: 'foodtrackeraistack-foodimagesbucket01218028-jvq5m4xouwvl'
    }
  },
  API: {
    REST: {
      FoodTrackerAPI: {
        // Fixed the extra space at the beginning of the URL
        endpoint: 'https://bta3c8fot7.execute-api.us-east-1.amazonaws.com/prod/',
        region: 'us-east-1',
        defaultAuthMode: 'userPool',
      }
    }
  }
} as const;

// Run validation
if (!validateAwsConfig(awsConfig)) {
  console.error('Invalid AWS configuration. Application may not function correctly.');
}

export default awsConfig;